import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { I as IconButton } from '../Button/IconButton/IconButton-Copc-LdF.js';

/**
 * TODO: Add to storm-ui-icons package during next minor version bump
 */
const stop = {
  prefix: 'fas',
  iconName: 'stop',
  icon: [448, 512, [], '', 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z']
};
const StopButton = ({
  onClick,
  disabled
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'stop-button'
  });
  const sendMessageLabel = formatMessage({
    id: 'action-stop'
  });
  return /*#__PURE__*/React__default.createElement(IconButton, _extends({}, getDataTaktAttributes(), {
    variant: "primary",
    onClick: onClick,
    disabled: disabled,
    icon: stop,
    label: sendMessageLabel,
    title: sendMessageLabel,
    small: true
  }));
};

export { StopButton as S };
//# sourceMappingURL=StopButton-D1a3CYdq.js.map
